module.exports = __webpack_public_path__ + "1160a7bf3671d974ed05638230d4f155.png";